import React, { useState, useRef } from 'react';
import { FaTv, FaDesktop, FaLaptop, FaTimes, FaChromecast, FaApple, FaAmazon, FaPlug } from 'react-icons/fa';

const DisplayOptions = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const hideTimersRef = useRef({});

  const devices = [
    { icon: <FaTv />, label: 'TV / Projecteur' },
    { icon: <FaDesktop />, label: 'Moniteur' },
    { icon: <FaLaptop />, label: 'Ordinateur portable' },
  ];

  const handleDeviceClick = (idx) => {
    if (hideTimersRef.current[idx]) clearTimeout(hideTimersRef.current[idx]);
    setActiveIndex(idx);
    hideTimersRef.current[idx] = setTimeout(() => {
      setActiveIndex((current) => (current === idx ? null : current));
    }, 1500);
  };

  return (
    <div className="display-options">
      <div className="display-icons-row">
        <span className="display-label">Peut être affiché sur :</span>

        {devices.map((device, index) => (
          <button
            key={index}
            className={`device-chip ${activeIndex === index ? 'active' : ''}`}
            type="button"
            aria-label={device.label}
            onClick={() => handleDeviceClick(index)}
          >
            {device.icon}
            <span className={`tooltip ${activeIndex === index ? 'visible' : ''}`}>
              {device.label}
            </span>
          </button>
        ))}

        <button
          className="howto-link"
          type="button"
          onClick={() => setShowPopup(true)}
        >
          Comment faire ?
        </button>
      </div>

      {showPopup && (
        <div
          className="review-modal-overlay-display"
          role="dialog"
          aria-modal="true"
          onClick={() => setShowPopup(false)}
        >
          <div className="review-modal" onClick={(e) => e.stopPropagation()}>
            <div className="review-modal-header">
              <span>Comment connecter le diaporama à des écrans externes ?</span>
              <button className="close-btn" onClick={() => setShowPopup(false)} aria-label="Fermer">
                <FaTimes />
              </button>
            </div>

            <p className="modal-text">
              Le diaporama est un lien web qui peut être affiché sur tout appareil avec un navigateur (Chrome, Safari, etc.).
            </p>
            <p className="modal-text">
              Les étapes exactes dépendent de votre matériel. Voici des méthodes courantes :
            </p>

            <div className="help-links">
              <a className="help-link-item" href="#">
                <FaPlug /> Connexion avec un câble (HDMI)
              </a>
              <a className="help-link-item" href="#">
                <FaTv /> Connexion à une Smart TV
              </a>
              <a className="help-link-item" href="#">
                <FaChromecast /> Connexion via Chrome Cast
              </a>
              <a className="help-link-item" href="#">
                <FaApple /> Connexion via Apple TV
              </a>
              <a className="help-link-item" href="#">
                <FaAmazon /> Connexion via Amazon Fire TV Stick
              </a>
            </div>

            <div className="recaptcha-legal" style={{ marginTop: 12 }}>
              Astuce : en ajoutant le diaporama à l’écran d’accueil iOS, l’affichage est en plein écran.
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DisplayOptions;
